import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-badge-renderer',
    templateUrl: './badge-renderer.component.html',
    standalone: false
})
export class BadgeRendererComponent implements ICellRendererAngularComp {
  foreignCurrency: any;
  preApprovalBalance: any;

  constructor(private translate: TranslateService) {

  }

  initilize(params: ICellRendererParams) {
    if (params && params.data) {
      if (params.data.spentCurrencyId >0) {
        this.foreignCurrency = this.translate.instant("fx_expense");
      }
    }
  }

  // called on init
  agInit(params: any): void {
    this.initilize(params);
  }

  // called when the cell is refreshed
  refresh(params: any): boolean {
    this.initilize(params);
    return true;
  }

}